import type { ScreenType } from '../../../types';

import GemMeterBaseRule from '../GemMeterBaseRule';
import { HARD_TO_READ_CONTENT } from '../../../constants/rulesConstants';

export default class TextSizeRule extends GemMeterBaseRule {
  static ruleId = HARD_TO_READ_CONTENT.id;

  static validate(selector: string, screenType: ScreenType) {
    let element = GemMeterBaseRule.getElement(selector);

    if (!element && selector.includes('.text-edit :first-child')) {
      const splitSelectors = selector.split(' ');
      element = GemMeterBaseRule.getElement(splitSelectors[0] + '.text-edit');
    }

    if (!element) {
      return true;
    }

    const elementStyle = getComputedStyle(element);
    const fontSize = parseFloat(elementStyle.fontSize.replace('px', ''));
    const tagName = element.tagName;
    if (['H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'div'].includes(tagName)) {
      return fontSize >= 11;
    } else {
      return fontSize >= 10;
    }
  }
}
